import React from 'react'

export const WhoGetsNotifiedHeader = () => (
  <div className='d-flex flex-column'>
    <div className='paragraph-medium medium'>Who gets notified</div>
    <ul className='paragraph-small zocks-text-gray-600 ps-3 mb-0'>
      <li>For private meetings, only the meeting owner will receive email notifications.</li>
      <li>
        For shared meetings, notifications will be sent exclusively to the members it has been shared with, ensuring that only the relevant individuals are kept
        informed.
      </li>
    </ul>
  </div>
)
